import * as React from "react";

import styled from "../../theme/styled";
import {
  DynamicWrapper,
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphCodeSnippetWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
}

const ParagraphCodeSnippetWrapper = styled<
  IParagraphCodeSnippetWrapper,
  "aside"
>("aside")`
  .content-container {
    .content-wrapper {
      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }
`;

/**
 * @see https://github.com/securingsincity/react-ace/issues/162
 */
const ParagraphCodeSnippet = ({ type, content }: IProps) => {
  if (typeof window !== "undefined") {
    const AceEditor = require("react-ace").default;

    require("brace/mode/css");
    require("brace/mode/html");
    require("brace/mode/java");
    require("brace/mode/javascript");
    require("brace/mode/json");
    require("brace/mode/markdown");
    require("brace/mode/mysql");
    require("brace/mode/php");
    require("brace/mode/plain_text");
    require("brace/mode/python");
    require("brace/mode/ruby");
    require("brace/mode/sass");
    require("brace/mode/swift");
    require("brace/mode/typescript");
    require("brace/theme/solarized_dark");

    return (
      <ParagraphCodeSnippetWrapper
        className="paragraph-code-snippet"
        type={type}
      >
        <DynamicWrapper type={type}>
          <AceEditor
            style={{ width: "100%" }}
            mode={content.field_code_snippet_type || "plain_text"}
            theme="solarized_dark"
            value={content.field_code_snippet}
            editorProps={{ $blockScrolling: true }}
            setOptions={{
              useWorker: false,
              highlightActiveLine: false,
              cursorStyle: "ace",
              fadeFoldWidgets: true
            }}
            readOnly
            scrollMargin={[ 22, 22 ]}
            showPrintMargin={false}
            maxLines={Infinity}
          />
        </DynamicWrapper>
      </ParagraphCodeSnippetWrapper>
    );
  }

  return null;
};

export default ParagraphCodeSnippet;
